import React from 'react'

import calendarLogo from '../images/icon_calendar.svg'

function LogoCalendar() {
	return <img src={calendarLogo} alt="Calendar Logo" />
}

export default LogoCalendar
